import React, { useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ServiceTransaction from "../services/ServiceTransaction";
import "./TransactionItem.css";
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from "@mui/material";

interface TransactionItemProps {
  item: ServiceTransaction<any>;
}

const TransactionItem: React.FC<TransactionItemProps> = ({ item }) => {
  // State
  const [, setTimestamp] = useState<string>("");

  // Other

  //

  React.useEffect(() => {
    const handler = (_transaction: ServiceTransaction<any>) => {
      // handle update here
      setTimestamp(new Date().toISOString());
    };
    const unsubscribe = item.onUpdated(handler);
    return () => {
      // Clean up the subscription when the component unmounts
      // rather than calling offUpdated directly, we use the unsubscribe function returned by onUpdated
      unsubscribe();
      //item.offUpdated(handler);
    };
  }, [item]);

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "6px", alignItems: "center" }}>
            <span>#{item.id}</span>
            <span>{item.status === "Success" ? <CheckCircleIcon className="success-icon" /> :
              item.status === "Failure" ? <ErrorIcon className="failure-icon" /> :
              <PendingIcon className="pending-icon" />}</span>
            <span>{item.request.method ? item.request.method : "-"}</span>
            <span>{item.request.url ? item.request.url.pathname : "-"}</span>
          </div>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer component={Paper} style={{ display: "inline-block", width: "auto" }}>
          <Table style={{ width: "auto" }}>
            <TableBody>
              <TableRow>
                <TableCell><strong>Status</strong></TableCell>
                <TableCell>{item.status}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><strong>Request QueryString</strong></TableCell>
                <TableCell>
                  {Array.from(item.request.url.searchParams.entries()).length > 0 ? (
                    <>
                      <TableContainer component={Paper} style={{ display: "inline-block", width: "auto" }}>
                        <Table style={{ width: "auto" }}>
                          <TableHead>
                            <TableRow>
                              <TableCell>Name</TableCell>
                              <TableCell>Value</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.from(item.request.url.searchParams.entries()).map(([name, value]) => (
                              <TableRow key={name}>
                                <TableCell>{name}</TableCell>
                                <TableCell>{value}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                  </>
                  ) : (
                    <p>None</p>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell><strong>Request Body</strong></TableCell>
                <TableCell>
                    {item.request.options?.body ? (
                    <pre className="transaction-body">{JSON.stringify(item.request.options.body, null, 2)}</pre>
                    ) : (
                    <p>No body sent</p>
                    )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};

export default TransactionItem;